interface IHeaderMenu {
  label: string;
  path: string;
}

export const clHeaderMenu: IHeaderMenu[] = [
  {
    label: 'About',
    path: '#about',
  },
  {
    label: 'Experience',
    path: '#experience',
  },
  {
    label: 'Portfolio',
    path: '#portfolio',
  },
  {
    label: 'Contact',
    path: '#contact',
  },
];
